import React, { Fragment, useState, useEffect } from 'react'
import Modal from "../../../common/Modal";
import School from '../../../../models/School'
import Package from '../../../../models/Package'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
const ClearExportModal = ({ }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [school, setSchool] = useState();
  const [selectedPackage, setSelectedPackage] = useState();

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const schoolId = $("[name='export[school_id]']")[0] && $("[name='export[school_id]']")[0].value
  const packageId = $("[name='export[package_id]']")[0] && $("[name='export[package_id]']")[0].value

  useEffect(() => {
    if (schoolId) {
      School
        .find(schoolId)
        .then((res) => {
          setSchool(res.data);
        })
    }

    if (packageId) {
      Package
        .find(packageId)
        .then((res) => {
          setSelectedPackage(res.data);
        })
    }
  }, [isOpen])

  const submit = () => {
    const data = new FormData();
    data.append('school_id', schoolId);
    data.append('package_id', packageId);

    fetch('/api/v1/order_packages/clear_exported_items',
      { method: 'POST', body: data })
      .then(res => {
        toast('Successfully cleared the exported items')
        setIsOpen(false)
      })
      .catch(() => {
        toast('There was an error clearing the exported items. Please try again.',
          { type: 'error' })
      })
  }

  const renderInfo = () => {
    if (!selectedPackage && !school) {
      return ''
    }
    if (selectedPackage && !school) {
      return `for the ${selectedPackage.name} pricelist`
    }

    if (!selectedPackage && school) {
      return `for the ${school.name} school`
    }

    return `for the ${selectedPackage.name} pricelist and the ${school.name} school`
  }

  const renderModal = () => {
    if (!isOpen) return;

    return (
      <Modal
        modalIsOpen={isOpen}
        closeModal={closeModal}
        contentLabel="Export"
        headerText="Clear Exported Shipped Items"
        secondaryButton={<button className="btn btn-secondary" onClick={closeModal}>Cancel</button>}
        primaryButton={<button className="btn btn-primary" onClick={(e) => submit()}>Continue</button>}
      >
        <div>
          <p>
            This will clear all previously exported items {renderInfo()} that have not been shipped yet.
            This will allow items to be re-exported again.
            <br/>
            Continue?
          </p>
        </div>
      </Modal>
    )
  }

  return (
    <Fragment>
      {renderModal()}
      <a onClick={openModal} className="btn btn-secondary">Clear exported items</a>
    </Fragment>
  )
}

export default ClearExportModal;
